module.exports = __webpack_public_path__ + "static/media/james.a9d5bc3a.jpg";